import ButtonNew from "components/atoms/ButtonNew/index";
import Img from "components/atoms/Img";

import Styles from "./Index.module.scss";

const BannerBankingTool = ({ data }) => {
  return (
    <section>
      <div className="container">
        <div
          style={{
            boxShadow: "0px 4px 16px rgba(37, 37, 37, 0.25)",
          }}
          className="relative flex h-auto w-full flex-col items-center overflow-hidden rounded-3xl bg-bbc-package lg:h-[414px] lg:flex-row"
        >
          <div className="col-12 relative z-10 mb-4 items-center lg:col-7 lg:mb-0">
            <div className="pl-4 pt-9 pr-4 lg:pt-0 lg:pl-16 lg:pr-10 xl:pr-4">
              <p
                className="mb-6 text-2xl font-semibold leading-[44px] text-white lg:mb-10 lg:text-3xl"
                dangerouslySetInnerHTML={{ __html: data.content }}
              />
              <ButtonNew
                as="a"
                href="/guide-and-tool/banking-tool"
                useRouter={true}
                btnColor="bg-white hover:bg-bbc-brand-500"
                btnTextColor="text-bbc-brand-500 hover:text-white"
                style={{ boxShadow: "0px 4px 16px rgba(37, 37, 37, 0.25)" }}
              >
                TRY IT NOW
              </ButtonNew>
            </div>
          </div>
          <div
            style={{
              fontSize: "0px",
            }}
            className="col-12 relative z-10 self-end pl-4 pr-2 text-center leading-none lg:col-5 lg:px-0 lg:text-left"
          >
            <Img {...data.image} />
          </div>
          <div className={Styles.bgBankingTool}></div>
        </div>
      </div>
    </section>
  );
};

export default BannerBankingTool;
